const generatePasswordSimple = (
  length = 16,
  wishlist = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$',
) =>
  Array.from(crypto.getRandomValues(new Uint32Array(length)))
    .map((x) => wishlist[x % wishlist.length])
    .join('')

export const generatePassword = () => {
  return `${generatePasswordSimple(10)}${generatePasswordSimple(2, '0123456789')}${generatePasswordSimple(2, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ')}${generatePasswordSimple(2, '~!@-#$')}`
}
